import React from 'react';
import { Box } from '@mui/material';
import TimeSliderCrossborder from '../components/sliders/slider_analy_crossborder.js';
import './styles/view-analytics.css';
// Graphs
import TemporalGraph from '../components/analytics-components/graph_temporal_analy.js';
// Custom hooks
import { useAnalyticsState } from '../hooks/useAnalyticsState.js';
import { useAuthentication } from '../hooks/useAuthentication.js';
// Configuration
import { 
  getAnalyticsModelDisplayName, 
  getAnalyticsMetricsName, 
  getAnalyticsCrossborderMetricsName 
} from '../config/analytics.js';
// Components
import TabPanel from '../components/common/TabPanel.js';
import BottomTabBar from '../components/performance-components/BottomTabBar.js';
import AnalyticsMapContainer from '../components/analytics-components/AnalyticsMapContainer.js';
import AnalyticsButtonsContainer from '../components/analytics-components/AnalyticsButtonsContainer.js';
import LoadingBackdrop from '../components/common/LoadingBackdrop.js';
import Login from '../components/login/login.js';

/**
 * Analytics Data Visualization Component
 * Displays weather forecast models, ground truth data, and cross-border analysis
 */

function DataVisualization() {
  // Custom hooks for state management
  const {
    cqlSevere,
    cqlFecha,
    cqlFechaMin,
    cqlFechaMax,
    weekNumber,
    fechaMinSlider,
    mapLeftLayer,
    mapRightLayer,
    mapCrossborderLayer,
    selectedModel,
    issueTime,
    issueTimeFRDT,
    selectedTime,
    crossIssueTime,
    crossSelectedTime,
    issueTimeOptions,
    tabIndex,
    backdropOpen,
    setIssueTimeOptions,
    handleDateChange,
    handleModelClick,
    handleSliderTimeChange,
    handleRiskClick,
    handleDateSelect,
    handleCrossDateSelect,
    handleTimeSelect,
    handleCrossTimeSelect,
    handleTabChange,
    handleBackdropOpen,
    handleBackdropClose,
  } = useAnalyticsState();

  // Authentication hook
  const { isAuthenticatedRight: isAuthenticatedUser, handleLogin: handleLoginUser } = useAuthentication();

  // Computed values
  const prettyModelName = getAnalyticsModelDisplayName(selectedModel);
  const metricsName = getAnalyticsMetricsName(selectedModel);
  const crossborderMetricsName = getAnalyticsCrossborderMetricsName(selectedModel);





  // Si el usuario no está autenticado, mostrar la pantalla de login
  if (!isAuthenticatedUser) {
    return <Login onLogin={handleLoginUser} />;
  }

  return (
    <div className="analytics-container">
      <TabPanel value={tabIndex} index={0}>
        <AnalyticsMapContainer
          prettyModelName={prettyModelName}
          issueTime={issueTime}
          cqlSevere={cqlSevere}
          cqlFecha={cqlFecha}
          mapLeftLayer={mapLeftLayer}
          weekNumber={weekNumber}
          selectedTime={selectedTime}
          isAuthenticatedUser={isAuthenticatedUser}
          mapRightLayer={mapRightLayer}
          selectedModel={selectedModel}
          mapCrossborderLayer={mapCrossborderLayer}
          crossIssueTime={crossIssueTime}
          crossSelectedTime={crossSelectedTime}
          onLogin={handleLoginUser}
        />

        <AnalyticsButtonsContainer
          cqlFecha={cqlFecha}
          selectedModel={selectedModel}
          cqlFechaMax={cqlFechaMax}
          cqlFechaMin={cqlFechaMin}
          issueTimeOptions={issueTimeOptions}
          issueTime={issueTime}
          crossIssueTime={crossIssueTime}
          onDateChange={handleDateChange}
          onModelClick={handleModelClick}
          onDateSelect={handleDateSelect}
          onTimeSelect={handleTimeSelect}
          onCrossDateSelect={handleCrossDateSelect}
          onCrossTimeSelect={handleCrossTimeSelect}
          onBackdropOpen={handleBackdropOpen}
          onBackdropClose={handleBackdropClose}
          setIssueTimeOptions={setIssueTimeOptions}
        />

        <div>
          <TimeSliderCrossborder 
            initialDate={fechaMinSlider} 
            steps={14} 
            onChange={handleSliderTimeChange} 
            fechaMinSlider={fechaMinSlider} 
          />
        </div>
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <div className="graphic-time-analytics">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              mx: 2,
              position: 'relative',
              cursor: 'crosshair',
            }}
          >
            <Box sx={{ paddingTop: '-30px' }}>
              <TemporalGraph
                cqlFecha={cqlFecha}
                cqlFechaMax={cqlFechaMax}
                cqlFechaMin={cqlFechaMin}
                issueTime={issueTimeFRDT}
                crossIssueTime={crossIssueTime}
                cqlSevere={cqlSevere}
                weekNumber={weekNumber}
                metricsNames={metricsName}
                metricsNamesCrossborder={crossborderMetricsName}
                issueTimeOptions={issueTimeOptions}
                selectedTime={selectedTime}
                mapLeftLayer={mapLeftLayer}
                handleRiskClick={handleRiskClick}
              />
            </Box>
          </Box>
        </div>
        
        <AnalyticsButtonsContainer
          cqlFecha={cqlFecha}
          selectedModel={selectedModel}
          onDateChange={handleDateChange}
          onModelClick={handleModelClick}
          layout="simple"
          showCrossBorderControls={false}
        />

        {/* <div className="graphic-table-analytics">
          <DataTable
            cqlFecha={cqlFecha}
            issueTime={issueTime}
            crossIssueTime={crossIssueTime}
            cqlSevere={cqlSevere}
            weekNumber={weekNumber}
            metricsNames={metricsNames[selectedModel]}
            metricsNamesCrossborder={metricsNamesCrossborder[selectedModel]}
            selectedTime={selectedTime}
            onChangeCrossIssueTime={setCrossIssueTime}  // Función vacía para evitar el error
          />
        </div> */}
      </TabPanel>

      <LoadingBackdrop open={backdropOpen} />
      <BottomTabBar tabIndex={tabIndex} onTabChange={handleTabChange} />
    </div>
  );
}

export default DataVisualization;
